/* ==========================================================================
   AGDEL — Pyramide olfactive  (Itération 3/4)
   Onglets Tête / Cœur / Fond : clic + clavier (flèches, Home, End).
   L'animation des ingrédients est en CSS : elle se rejoue à chaque
   affichage d'un panneau (retrait de l'attribut hidden).
   ========================================================================== */
(() => {
  'use strict';

  const init = (scope = document) => {
    scope.querySelectorAll('[data-pyramid]:not([data-pyramid-bound])').forEach((root) => {
      root.setAttribute('data-pyramid-bound', '');
      const tabs = [...root.querySelectorAll('[role="tab"]')];
      const panels = tabs.map((t) => root.querySelector(`#${t.getAttribute('aria-controls')}`));

      const select = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          const on = i === index;
          tab.setAttribute('aria-selected', String(on));
          tab.tabIndex = on ? 0 : -1;
          if (panels[i]) panels[i].hidden = !on;
        });
        if (focus) tabs[index].focus();
      };

      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(i));
        tab.addEventListener('keydown', (e) => {
          const last = tabs.length - 1;
          const keys = {
            ArrowDown: Math.min(i + 1, last), ArrowRight: Math.min(i + 1, last),
            ArrowUp: Math.max(i - 1, 0), ArrowLeft: Math.max(i - 1, 0),
            Home: 0, End: last,
          };
          if (e.key in keys) { e.preventDefault(); select(keys[e.key], true); }
        });
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
